import type { TestError } from '@playwright/test/reporter';

const ansiRegex = new RegExp(
  '([\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)|(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~])))',
  'g',
);
function stripAnsiEscapes(str: string | undefined): string | undefined {
  if (!str) return str;
  return str.replace(ansiRegex, '');
}

export function parseError(error: TestError) {
  return {
    message: stripAnsiEscapes(error.message),
    stack: stripAnsiEscapes(error.stack),
    snippet: stripAnsiEscapes(error.snippet),
  };
}
